var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m52.693 2.773 8.534 8.534-7.68 7.466-8.32-8.32zm-2.773 19.84L29.653 42.667h-8.32v-8.32l20.054-20.054zM8.107 7.893h32l-5.334 5.334H12.16l-.213 1.28q-1.28 7.466-1.28 17.493t1.28 17.493l.213 1.067h34.347l.213-1.067Q48 42.027 48 32l5.333-5.333V32q0 7.467-.64 13.653a186 186 0 0 1-1.28 7.894l-.64 2.346H8.107l-.854-2.346a187 187 0 0 1-1.28-7.894q-.64-6.186-.64-13.653t.64-13.653q.64-4.48 1.28-7.894z"
  })));
};
export default SvgEdit;